import React, { memo } from "react";
import AerosNode, { NodeIcon } from "./AerosNode";
import { TONES } from "../flowRules";
import { i18n } from "../../../translate/i18n";

// item de data.seq é "<tipo>-<n>"; o elemento correspondente vem de data.elements.
const KINDS = [
  { key: "message", icon: "chat", field: "value" },
  { key: "interval", icon: "timer", field: "value", suffixKey: "aeros.flow.content.seconds" },
  { key: "img", icon: "image", field: "original" },
  { key: "audio", icon: "mic", field: "original" },
  { key: "video", icon: "video", field: "original" },
  { key: "document", icon: "layers", field: "original" },
];

export default memo(({ data, id, isConnectable, selected }) => (
  <AerosNode id={id} type="singleBlock" selected={selected} isConnectable={isConnectable}>
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {(data.seq || []).map((item) => {
        const kind = KINDS.find((k) => item.includes(k.key));
        if (!kind) return null;
        const el = (data.elements || []).filter((e) => e.number === item)[0] || {};
        const text = `${el[kind.field] ?? ""}${kind.suffixKey ? ` ${i18n.t(kind.suffixKey)}` : ""}`;
        return (
          <div key={item} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, minWidth: 0 }}>
            <NodeIcon name={kind.icon} size={14} color={TONES.msg.color} />
            <span style={{ flex: 1, minWidth: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {text}
            </span>
          </div>
        );
      })}
    </div>
  </AerosNode>
));
